import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './es.json';
import en from './en.json';

/**
 * i18next configuration.
 *
 * - Detects the user language from localStorage / navigator (in that order).
 * - Falls back to English (`en`) — the primary market is US/Canada, so an
 *   unknown/undetectable visitor should see English, not Spanish.
 * - `load: 'languageOnly'` strips the region subtag so a browser reporting
 *   `en-US` / `en-GB` resolves to `en` (and `es-MX` → `es`). Without it,
 *   region-tagged locales miss the explicit supportedLngs list and wrongly
 *   fall through to `fallbackLng` — which is how US customers on an en-US
 *   browser were landing in Spanish.
 * - One namespace (`default`) — the bundles are flat key/value maps lifted
 *   from `STR.es` / `STR.en` in design/app-shell.jsx.
 *
 * TODO(F2.5-B): split namespaces by feature (`auth`, `dashboard`, `campaigns`)
 * once the bundles grow beyond a few hundred keys.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { default: es },
      en: { default: en },
    },
    fallbackLng: 'en',
    supportedLngs: ['es', 'en'],
    load: 'languageOnly',
    defaultNS: 'default',
    ns: ['default'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'ezsender:lang',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
